const Mock = require('mockjs');
// 获取 mock.Random 对象
const Random = Mock.Random;

const produceNewsData = function() {
  let gamelists = [];
  for (let i = 0; i < 3; i++) {
      let gameObject = {
          title: Random.csentence(5, 10), //  Random.csentence( min, max )
          thumbnail_pic_s: Random.dataImage('385x236', 'mock的图片'), // Random.dataImage( size, text ) 生成一段随机的 Base64 图片编码
          subscribe: Random.csentence(70, 150),
          date: Random.date() + ' ' + Random.time() // Random.date()指示生成的日期字符串的格式,默认为yyyy-MM-dd；Random.time() 返回一个随机的时间字符串
      }
      gamelists.push(gameObject)
  }

  return {
    "code": 0,
    "message": 'success',
    gamelists
  }
}

export default {
  getGameList: config => {
    return produceNewsData()
  }
}



// WEBPACK FOOTER //
// ./src/mock/home.js